import { render, staticRenderFns } from "./NavigationItem.vue?vue&type=template&id=21a43d62&"
import script from "./NavigationItem.vue?vue&type=script&lang=js&"
export * from "./NavigationItem.vue?vue&type=script&lang=js&"
import style0 from "./NavigationItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports